import { Box, Button, IconButton, Step, StepLabel, Stepper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { colors } from "../../../../theme/palette";
import {
  BackArrowIcon,
  PaymentDetailsIcon,
  RegisterFormFieldsIcon,
  ReviewAndSharePaymentIcon,
  SelectRecipientIcon,
} from "../../../../assets/icons/MUI/PaymentIcons";
import APP_ROUTES from "../../../../routers/routeConstants";

const HowItWorks = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const steps = [
    { title: t("pages.payment.howItWorks.reviewAndShare"), icon: <ReviewAndSharePaymentIcon /> },
    { title: t("pages.payment.howItWorks.registrationFormFields"), icon: <RegisterFormFieldsIcon /> },
    { title: t("pages.payment.howItWorks.selectRecipient"), icon: <SelectRecipientIcon /> },
    { title: t("pages.payment.howItWorks.paymentDetails"), icon: <PaymentDetailsIcon /> },
  ];

  return (
    <Box
      sx={{
        padding: "112px 0 12px",
        background: colors.White,
        borderRadius: "8px",
        border: "1px solid #EAECF0",
        width: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        rowGap: "24px",
        position: "relative",
      }}
    >
      <IconButton
        onClick={() => navigate(APP_ROUTES.PAYMENT)}
        sx={{
          width: "fit-content",
          position: "absolute",
          top: "24px",
          left: "24px",
        }}
      >
        <BackArrowIcon />
      </IconButton>
      <Typography
        component="h2"
        sx={{
          color: "#1D1D1D",
          textAlign: "center",
          fontFamily: "Montserrat",
          fontSize: "32px",
          fontStyle: "normal",
          fontWeight: 800,
          lineHeight: "normal",
          marginBottom: "6px",
        }}
      >
        {t("pages.payment.howItWorks.createPaymentLink")}
      </Typography>
      <Typography
        component="h2"
        sx={{
          color: "#232323",
          textAlign: "center",
          fontFamily: "Montserrat",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "150%",
          marginBottom: "55px",
        }}
      >
        {t("pages.payment.howItWorks.collectPayment")}
      </Typography>
      <Box
        sx={{
          display: "flex",
          padding: "48px 32px",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "64px",
          borderRadius: "16px",
          background: "#F3F7F6",
          margin: "0 24px 24px",
        }}
      >
        <Box>
          <Typography
            component="h3"
            sx={{
              color: "#111",
              textAlign: "center",
              fontFamily: "Montserrat",
              fontSize: "20px",
              fontStyle: "normal",
              fontWeight: 800,
              lineHeight: "normal",
              marginBottom: "24px",
            }}
          >
            {t("pages.payment.howItWorks.title")}
          </Typography>
          <Typography
            component="h4"
            sx={{
              color: "#1C1C1C",
              textAlign: "center",
              fontFamily: "Montserrat",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: "normal",
              marginBottom: "8px",
            }}
          >
            {t("pages.payment.howItWorks.description")}
          </Typography>
          <Typography
            component="p"
            sx={{
              color: "#707070",
              textAlign: "center",
              fontFamily: "Montserrat",
              fontSize: "13px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "normal",
              maxWidth: "382px",
            }}
          >
            {t("pages.payment.howItWorks.customizeAndCollect")}
          </Typography>
        </Box>
        <Stepper activeStep={1} alternativeLabel>
          {steps.map(({ title, icon }, idx) => (
            <Step key={idx}>
              <StepLabel StepIconComponent={() => icon}>{title}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
      <Box
        sx={{
          paddingTop: "12px",
          borderTop: "1px solid #EAECF0",
          padding: "12px 24px 0",
        }}
      >
        <Button
          variant="primary-md"
          sx={{
            display: "block",
            marginLeft: "auto",
          }}
          onClick={() => navigate(APP_ROUTES.CREATE_PAYMENT_LINK)}
        >
          {t("pages.payment.howItWorks.continue")}
        </Button>
      </Box>
    </Box>
  );
};

export default HowItWorks;
